// extracted by mini-css-extract-plugin
export default {"wrapper":"SubHeader_wrapper__7niOn","visible":"SubHeader_visible__eiTih","list":"SubHeader_list__iRhY2","active":"SubHeader_active__URu4S"};